export default class SoundManager {
    static preloadMenu(scene){
        scene.load.audio('button_click', [
            'src/assets/sounds/button_click.mp3',
            'src/assets/sounds/button_click.ogg'
        ]);

        scene.load.audio('intro', [
            'src/assets/sounds/menu_music.mp3',
            //'src/assets/sounds/music_magical_story_intro.ogg'
        ]);
    }

    static preloadGame(scene){
        scene.load.audio('title', [
            'src/assets/sounds/music.mp3',
            //'src/assets/sounds/music.ogg'
        ]);
        scene.load.audio('jump', ['src/assets/sounds/jump.mp3', 'src/assets/sounds/jump.ogg']);
    }

    static init(game){
        this.game = game;
        this.sounds = {};
        this.currentMusic = null;
        this.currentMusicKey = null;
    }

    static addFX(key, volume = 1){
        this.sounds[key] = this.game.sound.add(key, {volume});
    }

    static playFX(key, loop = false){
        this.sounds[key].play();
        this.sounds[key].setLoop(loop);
    }
    static playMusic(key){
        if(this.currentMusicKey === key) return;
        if(this.currentMusic) this.currentMusic.stop();
        this.currentMusic = this.sounds[key];
        this.currentMusicKey = key;
        this.playFX(key, true);
    }
}